import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReferrersDropdownTemplate from "@Broker/@HandlebarsTemplates/clients/board/table/_referrers-dropdown.hbs";
import AssigneeDropdownTemplate from "@Shared/@HandlebarsTemplates/general/_assignee-dropdown.hbs";
import Select2 from "@Shared/components/inputs/select2";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientBoardSelectFilter",
  components: {
    Select2
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      required: true
    },
    resultsTemplateName: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: null,
      default: ""
    },
    data: {
      type: [Object, Array],
      default: null
    },
    capitalize: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectTemplateMap: {
        "referrers-dropdown": ReferrersDropdownTemplate,
        "assignee-dropdown": AssigneeDropdownTemplate
      },
      select2Options: {}
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initSelect2();
    });
  },
  methods: {
    getSelect2Options() {
      const formatResult = state => $(this.selectTemplateMap[this.resultsTemplateName](_objectSpread(_objectSpread({}, state), {}, {
        createAsNewReferrer: this.$t("referrers.actions.createAsNewReferrer")
      })));
      return {
        templateResult: formatResult,
        placeholder: this.placeholder,
        dropdownParent: $(`#${this.name}-select--container`),
        closeOnSelect: false
      };
    },
    handleSelect2Change(data, type) {
      this.$emit("change", data, type, this.name);
    },
    formatData(data) {
      return data && _mapInstanceProperty(data).call(data, ref => {
        if (ref.id === "null") return ref;
        ref.id = ref.id || ref.username;
        ref.text = `${ref.givenName} ${ref.familyName}`;
        return ref;
      });
    },
    initSelect2() {
      this.$nextTick(() => {
        this.select2Options = this.getSelect2Options();
        this.$refs.select.initSelect2();
      });
    }
  }
});